import { Component, OnInit } from '@angular/core';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
  SuiModalService,
} from '@richardlt/ng2-semantic-ui';
import { EwalletService } from 'src/modules/features/admin/services/ewallet';
import { ChangeBankDetailsModal } from '../change-bank-details-modal/change-bank-details-modal.component';
import { ConfirmModal } from '@app/shared/modals';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

interface IRequestWithdrawalModalContext {
  account: any;
  closeAccount: boolean;
}
@Component({
  selector: 'app-request-withdrawal-modal',
  templateUrl: './request-withdrawal-modal.component.html',
  styleUrls: ['./request-withdrawal-modal.component.scss'],
})
export class RequestWithdrawalModalComponent implements OnInit {
  error: any;
  success: any;
  pending2 = false;
  // amount: number;
  charges: number = 0;
  fixedCharge: number = 0;
  percentageCharge: number = 0;
  chargesArray;
  requestWithdrawalForm: FormGroup;
  constructor(
    public modal: SuiModal<IRequestWithdrawalModalContext, any, any>,
    private walletService: EwalletService,
    private modalService: SuiModalService,
    private router: Router,
    private fb: FormBuilder
  ) {
    this.requestWithdrawalForm = fb.group({
      amount: [
        '',
        [
          Validators.required,
          Validators.maxLength(11),
          Validators.pattern(/[0-9]/),
        ],
      ],
    });
    console.log(this.modal.context.account, 'this.modal.context.account');
  }

  ngOnInit(): void {
    // this.getTax();
    this.getCharges();
  }

  dataToJSON(data: any) {
    return JSON.parse(data);
  }

  // getTax() {
  //   this.pending2 = true;
  //   this.walletService.getWithdrawalTaxPercent().subscribe(
  //     (res: number) => {
  //       this.pending2 = false;
  //       this.taxes = res;
  //     },
  //     (error) => {
  //       this.pending2 = false;
  //       this.error = error.error;
  //     }
  //   );
  // }
  // [{
  //   chargeId: '80c8e82a-83a4-4ea4-95fb-b703b783f525',
  //   name: 'VAT',
  //   description: 'Value Added Tax',
  //   fixedPercentage: 'Percentage',
  //   localValue: 7.5,
  //   foreignValue: 7.5,
  //   defaultRevenueServiceCategories: null,
  //   status: null,
  //   accountNo: '8837733',
  //   accountCode: '665333',
  //   dateCreated: '2022-03-23T03:09:24.617+0000',
  //   dateModified: '2024-01-22T17:24:35.733+0000',
  //   createdBy:
  //     '{"appUserId":"cf7cdab4-77c7-4223-917d-cbc6cb20b569","username":"finance-admin","name":"Finance Admin","organizationId":"70b3fbd7-9281-4f7f-9ba2-5c439ae993ce","organizationName":"Finance Department"}',
  //   modifiedBy:
  //     '{"appUserId":"cf7cdab4-77c7-4223-917d-cbc6cb20b569","username":"finance-admin","name":"Finance Admin","organizationId":"70b3fbd7-9281-4f7f-9ba2-5c439ae993ce","organizationName":"Finance Department"}',
  // }];
  getCharges() {
    this.pending2 = true;
    this.walletService.getWithdrawalCharges().subscribe(
      (res: any[]) => {
        this.chargesArray = res;
        for (const charge of res) {
          if (charge.fixedPercentage === 'Fixed') {
            this.fixedCharge +=
              this.modal.context.account.currencyId == 'naira'
                ? charge.localValue
                : charge.foreignValue;
          } else {
            this.percentageCharge +=
              this.modal.context.account.currencyId == 'naira'
                ? charge.localValue
                : charge.foreignValue;
          }
        }
        this.pending2 = false;
        console.log(
          this.modal.context.account?.balance - this.getTotal() < 0,
          'charges'
        );
      },
      (error) => {
        this.pending2 = false;
        this.error = error.error;
      }
    );
  }
  getTotalCharges() {
    if (this.modal.context.closeAccount) {
      const balance = this.modal.context.account?.balance;
      return (this.percentageCharge * balance) / 100 + this.fixedCharge;
    } else {
      return (
        (this.percentageCharge *
          parseInt(this.requestWithdrawalForm.value.amount)) /
          100 +
        this.fixedCharge
      );
    }
  }
  getChargesFigure(charge) {
    return (charge * parseInt(this.requestWithdrawalForm.value.amount)) / 100;
  }
  getClosingChargesFigure(charge) {
    return (charge * this.getTotal()) / 100;
  }
  // formula used to calculate total amount for withdrawal
  // (x + 0.075x (VAT, 7.5%) + 500(withhold tax, fixed)) = 10,000 (Balance).
  calculateWithdrawalAmount(total, withholdTax, vatRate) {
    let x = (total - withholdTax) / (1 + vatRate);
    return x;
  }
  getTotal() {
    if (this.modal.context.closeAccount) {
      const balance = this.modal.context.account?.balance;
      this.requestWithdrawalForm.value.amount = balance;
      return balance
        ? this.calculateWithdrawalAmount(
            balance,
            this.fixedCharge,
            this.percentageCharge / 100
          )
        : 0.0;
    }
    return this.requestWithdrawalForm.value.amount
      ? parseInt(this.requestWithdrawalForm.value.amount) +
          this.getTotalCharges()
      : 0.0;
  }

  formatAmount(amount: any) {
    return Number(amount).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }
  checkBalance() {
    if (this.modal.context.closeAccount) {
      return (
        parseInt(this.requestWithdrawalForm.value.amount) >
        this.modal.context.account?.balance
      );
    } else {
      return (
        this.getTotal() > this.modal.context.account?.balance ||
        this.requestWithdrawalForm.value.amount <
          this.modal.context.account?.minWithdrawalAmount
      );
    }
  }
  submit() {
    if (
      !this.modal.context.closeAccount &&
      this.getTotal() > this.modal.context.account?.balance
    ) {
      this.error = 'The Total Amount to withdraw is more than your balance';
      return;
    }
    if (
      !this.modal.context.closeAccount &&
      parseInt(this.requestWithdrawalForm.value.amount) <
        this.modal.context.account?.minWithdrawalAmount
    ) {
      this.error =
        'The  Amount to withdraw is less than the minimum Withdrawal amount';
      return;
    }
    this.pending2 = true;
    const user = JSON.parse(localStorage.getItem('user'));
    const body = {
      customerWalletId: this.modal.context.account.customerWalletId,
      amount: this.modal.context.closeAccount
        ? this.calculateWithdrawalAmount(
            this.modal.context.account.balance,
            this.fixedCharge,
            this.percentageCharge / 100
          )
        : parseInt(this.requestWithdrawalForm.value.amount),
      createdBy: {
        appUserId: user.appUserId,
        username: user.username,
        name: user.firstName,
      },
      bankAccountHistoryId:
        this.modal.context.account.activeBankAccountHistoryId,
    };
    if (this.modal.context.closeAccount) {
      body['closing'] = true;
    }
    this.walletService.requestWithdrawal({ body }).subscribe(
      (res) => {
        this.pending2 = false;
        this.modal.approve(null);
      },
      (error) => {
        this.pending2 = false;
        this.error = error.error.errorMessage
          ? error.error.errorMessage
          : error.error.error
          ? error.error.error
          : error.error
          ? error.error
          : error;
      }
    );
  }

  changeBankDetails() {
    // this.modal.deny(true);
    this.modalService
      .open(new ChangeBankDetailsModal(this.modal.context.account))
      .onApprove(() => {
        this.modalService
          .open(
            new ConfirmModal(
              'Change Bank Details',
              'Your bank details change request has been received and submitted successfully.',
              ModalSize.Tiny,
              'Okay',
              ''
            )
          )
          .onApprove(() => {
            localStorage.setItem(
              'customerWalletId',
              this.modal.context.account.customerWalletId
            );
          });
      });
  }
}

export class RequestWithdrawalModal extends ComponentModalConfig<
  IRequestWithdrawalModalContext,
  any,
  any
> {
  constructor(
    account: any,
    closeAccount: boolean = false,
    size: ModalSize = ModalSize.Tiny
  ) {
    super(RequestWithdrawalModalComponent, { account, closeAccount });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
